interface Props {
  label: string;
  color?: string;
  size?: 'sm' | 'md';
}

export function StatusBadge({ label, color, size = 'sm' }: Props) {
  const bg = color ?? '#E2E8F0';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md font-medium whitespace-nowrap border ${
        size === 'md' ? 'px-2.5 py-1 text-sm' : 'px-2 py-0.5 text-xs'
      }`}
      style={{
        background: withAlpha(bg, 0.35),
        borderColor: withAlpha(bg, 0.7),
        color: darken(bg, 0.55),
      }}
    >
      <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: darken(bg, 0.25) }} />
      {label}
    </span>
  );
}

function withAlpha(hex: string, a: number): string {
  if (!hex.startsWith('#')) return hex;
  const n = parseInt(hex.slice(1), 16);
  const r = (n >> 16) & 0xFF, g = (n >> 8) & 0xFF, b = n & 0xFF;
  return `rgba(${r},${g},${b},${a})`;
}

function darken(hex: string, amount: number): string {
  if (!hex.startsWith('#')) return '#1E293B';
  const n = parseInt(hex.slice(1), 16);
  const r = Math.max(0, Math.round(((n >> 16) & 0xFF) * (1 - amount)));
  const g = Math.max(0, Math.round(((n >> 8) & 0xFF) * (1 - amount)));
  const b = Math.max(0, Math.round((n & 0xFF) * (1 - amount)));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}
